export default function ({commit}, {name, field, value}) {
    commit('column', {name, field, value});
}